import React from "react";
import Placeholder from "../../../../core-components/Shimmer/ShimmerUI";
import * as S from "./ReviewLoader.styles";

const ReviewLoaderUI = () => {
  return (
    <S.FiltersCont>
      <div className="filtersHeading">
        <div className="makeFlex spaceBetween hrtlCenter">
          <Placeholder
            ldrWidth="10.4rem"
            ldrHeight="5rem"
            margin="0 0 0.9rem 0"
          />
          <span className="clearText"></span>
        </div>
        <Placeholder ldrWidth="173px" ldrHeight="1.8rem" margin="0 0 0 0" />
      </div>
      <ul className="segmentWrap">
        <Placeholder
          ldrWidth="750px"
          ldrHeight="6rem"
          margin="0 2.5rem 1.3rem 0"
        />
        <Placeholder
          ldrWidth="750px"
          ldrHeight="6rem"
          margin="0 2.5rem 1.3rem 0"
        />
        <Placeholder
          ldrWidth="750px"
          ldrHeight="6rem"
          margin="0 2.5rem 1.3rem 0"
        />
      </ul>
      <S.LoadingFilters>
        <li>
          <Placeholder
            ldrWidth="750px"
            ldrHeight="1.8rem"
            margin="0.3rem 0.3rem 2.2rem 0.3rem"
          />
          <ul>
            <li>
              <Placeholder
                ldrWidth="300px"
                ldrHeight="1.8rem"
                margin="0 1.1rem 1.4rem 0"
              />
              <Placeholder
                ldrWidth="300px"
                ldrHeight="1.8rem"
                margin="0 0 1.3rem 0"
              />
            </li>
          </ul>
        </li>
        <li>
          <Placeholder
            ldrWidth="750px"
            ldrHeight="1.8rem"
            margin="0.3rem 0.3rem 2.2rem 0.3rem"
          />
          <ul>
            <li>
              <Placeholder
                ldrWidth="750px"
                ldrHeight="1.8rem"
                margin="0 0 1.3rem 0"
              />
            </li>
          </ul>
        </li>
      </S.LoadingFilters>
    </S.FiltersCont>
  );
};

export default ReviewLoaderUI;
